var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bige" }, [
    _c("section", { attrs: { id: "firstSection" } }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch:swipe",
              value: _vm.swipeHandler,
              expression: "swipeHandler",
              arg: "swipe"
            },
            {
              name: "touch",
              rawName: "v-touch:moving",
              value: _vm.movingHandler,
              expression: "movingHandler",
              arg: "moving"
            },
            {
              name: "touch",
              rawName: "v-touch:moved",
              value: _vm.movedHandler,
              expression: "movedHandler",
              arg: "moved"
            },
            {
              name: "touch",
              rawName: "v-touch:start",
              value: _vm.startHandler,
              expression: "startHandler",
              arg: "start"
            },
            {
              name: "touch",
              rawName: "v-touch:end",
              value: _vm.endHandler,
              expression: "endHandler",
              arg: "end"
            }
          ],
          staticClass: "head"
        },
        [
          _c("div", { staticClass: "slider" }, [
            _c(
              "div",
              { staticClass: "bigeSlider", attrs: { id: "bigeSlider" } },
              [
                _vm.notie
                  ? _c("div", {
                      staticClass: "prevNextButton prev notie",
                      class: { disabled: _vm.isFirst },
                      on: { click: _vm.slidePrev }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.notie
                  ? _c("div", {
                      staticClass: "prevNextButton next notie",
                      class: { disabled: _vm.isLast },
                      on: { click: _vm.slideNext }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wrapper", attrs: { id: "headerWrapper" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "item169",
                        on: {
                          click: function($event) {
                            return _vm.setCurrent(0)
                          }
                        }
                      },
                      [
                        _c(
                          "video",
                          {
                            attrs: {
                              poster: require("@/assets/videos/idtroc-video-poster.gif")
                            },
                            on: {
                              mouseover: _vm.displayVideoControls,
                              mouseleave: _vm.hideVideoControls
                            }
                          },
                          [
                            _c("source", {
                              attrs: {
                                src: require("@/assets/videos/why_idtroc.mp4"),
                                type: "video/mp4"
                              }
                            }),
                            _vm._v(" "),
                            _c("track", {
                              attrs: {
                                label: "French",
                                kind: "captions",
                                srclang: "fr",
                                src: "",
                                default: ""
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.notie
                      ? _c(
                          "div",
                          {
                            staticClass: "item169 notie",
                            on: {
                              click: function($event) {
                                return _vm.setCurrent(1)
                              }
                            }
                          },
                          [
                            _vm._m(7),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(
                                "L’application IDTROC, comment ça marche ?"
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Réservée aux membres des programmes fidélité OKÄIDI - OBAÏBI,\n                OXYBUL et ÏDKIDS, j’adhère en ligne ou en magasin pour\n                participer !\n              "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notie
                      ? _c(
                          "div",
                          {
                            staticClass: "item169 notie",
                            on: {
                              click: function($event) {
                                return _vm.setCurrent(2)
                              }
                            }
                          },
                          [
                            _vm._m(8),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v("Choisissez un IDTROC à proximité!")
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Grâce à l’application, je me géolocalise pour choisir mon\n                magasin participant à proximité.\n              "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notie
                      ? _c(
                          "div",
                          {
                            staticClass: "item169 notie",
                            on: {
                              click: function($event) {
                                return _vm.setCurrent(3)
                              }
                            }
                          },
                          [
                            _vm._m(9),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(
                                "Enregistrez et étiquetez vos articles à la maison !"
                              )
                            ]),
                            _vm._v(" "),
                            _vm._m(10)
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notie
                      ? _c(
                          "div",
                          {
                            staticClass: "item169 notie",
                            on: {
                              click: function($event) {
                                return _vm.setCurrent(4)
                              }
                            }
                          },
                          [
                            _vm._m(11),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(
                                "Déposez vos articles en magasin aux dates indiquées !"
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Après contrôle qualité du magasin, je mets en rayon mes\n                articles validés dans l’espace dédié.\n              "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notie
                      ? _c(
                          "div",
                          {
                            staticClass: "item169 notie",
                            on: {
                              click: function($event) {
                                return _vm.setCurrent(5)
                              }
                            }
                          },
                          [
                            _vm._m(12),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(
                                "Vos articles vendus se transforment en carte cadeau !"
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Je peux suivre mes ventes sur l’application. Le montant final\n                de mes ventes est crédité via l’application sans frais ni\n                commission sur ma carte cadeau !\n              "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notie
                      ? _c(
                          "div",
                          {
                            staticClass: "item169 notie",
                            on: {
                              click: function($event) {
                                return _vm.setCurrent(6)
                              }
                            }
                          },
                          [
                            _vm._m(13),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(
                                "Après la vente, donnez ou retirez vos invendus !"
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Je souhaite donner mes invendus ? Inutile de me déplacer,\n                après la date limite, ils seront automatiquement donnés à\n                l’organisme/association parrainée par le magasin !\n              "
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "dotNav notie" },
            _vm._l(_vm.items, function(item, index) {
              return _c("li", {
                class: { active: _vm.current === index },
                on: {
                  click: function($event) {
                    return _vm.setCurrent(index)
                  }
                }
              })
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _vm._m(14),
      _vm._v(" "),
      _c("div", { staticClass: "cols" }, [
        _c(
          "div",
          {
            staticClass: "centered osReverse",
            class: { reverse: _vm.isAndroid }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.global.apple_link,
                  title: _vm.global.download_apple,
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [
                _c("img", {
                  staticClass: "download_button",
                  attrs: {
                    src: require("@/assets/images/SVG/ios_download.svg"),
                    height: "48",
                    alt: "telechargez idtroc sur ios"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.global.google_link,
                  title: _vm.global.download_google,
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [
                _c("img", {
                  staticClass: "download_button",
                  attrs: {
                    src: require("@/assets/images/SVG/google_play_FR.svg"),
                    height: "48",
                    alt: "telechargez idtroc ur google play android"
                  }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("h2", {
        staticClass: "cont centered",
        domProps: { innerHTML: _vm._s(_vm.message) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "cols cont" }, [
        _vm._m(15),
        _vm._v(" "),
        _vm._m(16),
        _vm._v(" "),
        _vm._m(17),
        _vm._v(" "),
        _vm.showAll
          ? _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "icon icon64 idtroc-quality" }),
              _vm._v(" "),
              _c("h3", [_vm._v("En toute confiance")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Le magasin valide la qualité de vos articles, gère la relation avec\n          les clients et vous garantit le paiement de votre carte cadeau !\n        "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showAll
          ? _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "icon icon64 idtroc-giftcard" }),
              _vm._v(" "),
              _c("h3", [_vm._v("Obtenez des cartes cadeaux")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Récupérez 100% du montant de vos ventes en carte cadeau sans frais\n          ni commission, la vente est entièrement prise en charge par votre\n          magasin !\n        "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showAll
          ? _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "icon icon64 idtroc-give" }),
              _vm._v(" "),
              _c("h3", [_vm._v("Une démarche solidaire")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Après la vente, vous pouvez choisir de récupérer ou de donner vos\n          invendus à l’association ou organisation parrainée par le magasin !\n        "
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "centered" }, [
        _c(
          "a",
          {
            staticClass: "hyperlink",
            attrs: { id: "showMore" },
            on: { click: _vm.showMore }
          },
          [_vm._v(_vm._s(_vm.loadmore))]
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(18),
    _vm._v(" "),
    _vm._m(19),
    _vm._v(" "),
    _vm._m(20)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "parallax col1 notie", attrs: { "data-parallax": "2" } },
      [
        _c("div", {
          staticClass: "icon idtroc-tshirt",
          staticStyle: { top: "75vh", "font-size": "150px", width: "100px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "parallax col2 notie", attrs: { "data-parallax": "1" } },
      [
        _c("div", {
          staticClass: "icon idtroc-toy",
          staticStyle: { top: "70vh", "font-size": "250px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "parallax col5 notie", attrs: { "data-parallax": "1.5" } },
      [
        _c("div", {
          staticClass: "icon idtroc-book",
          staticStyle: { top: "55vh", "font-size": "200px", "z-index": "66" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "parallax col4 notie", attrs: { "data-parallax": "2.5" } },
      [
        _c("div", {
          staticClass: "icon idtroc-giving",
          staticStyle: { top: "85vh", "font-size": "150px", "z-index": "66" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "parallax col2 notie", attrs: { "data-parallax": "2.5" } },
      [
        _c("div", {
          staticClass: "icon idtroc-smart_hand_2",
          staticStyle: { top: "105vh", "font-size": "120px", "z-index": "66" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "parallax col3 notie", attrs: { "data-parallax": "2" } },
      [
        _c("div", {
          staticClass: "icon idtroc-shop",
          staticStyle: { top: "155vh", "font-size": "120px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "parallax col5 notie", attrs: { "data-parallax": "1" } },
      [
        _c("div", {
          staticClass: "icon idtroc-great",
          staticStyle: { top: "145vh", "font-size": "220px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/SVG/app_how_its_run.svg"),
          alt: "trouvez un idtroc proche de vous"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/SVG/trouver_un_idtroc.svg"),
          alt: "trouvez un idtroc proche de vous"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/SVG/ajoutez_vos_articles_idtroc.svg"),
          alt: "ajoutez vos articles vetements jeux et jouets"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                Nouveau ! J’imprime mes étiquettes de chez moi. Je n’ai pas\n                d’imprimante ?\n                "
      ),
      _c("br"),
      _vm._v("Mon magasin le fait pour moi !\n              ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/SVG/deposez_et_vendeez_en_magasin.svg"),
          alt: "déposez en magasin et mettez en vente"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/SVG/obtenez_votre_carte_cadeau_idtroc.svg"),
          alt: "obtenez des cartes cadeaux IDKIDS et ou Jacadi"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/SVG/donnez_vos_invendus.svg"),
          alt: "Suivez vos ventes et donnez ou récupéreez vos invendus"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v(
        "\n      Pour vendre vos articles en magasin OKAÏDI-OBAÏBI, OXYBUL, ÏDKIDS et CATIMINI,\n      "
      ),
      _c("br"),
      _vm._v(" "),
      _c("b", [_vm._v("téléchargez l’application !")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "icon icon64 idtroc-blob_idtroc" }, [
        _c("div", { staticClass: "ligature path1" }),
        _vm._v(" "),
        _c("div", { staticClass: "ligature path2" }),
        _vm._v(" "),
        _c("div", { staticClass: "ligature path3" })
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Faites un geste responsable")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          Faites le tri dans vos armoires, transmettez, recyclez et\n          engagez-vous pour une consommation plus responsable !\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "icon icon64 idtroc-product_add" }),
      _vm._v(" "),
      _c("h3", [_vm._v("Gérez vos articles")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          Grâce à l’application, trouvez les ventes IDTROC proches de chez\n          vous, ajoutez vos articles et récupérez vos étiquettes !\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "icon icon64 idtroc-shop_search" }),
      _vm._v(" "),
      _c("h3", [_vm._v("Vendez facilement")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          Déposez tous vos articles en une seule fois dans le magasin de votre\n          choix. Profitez de la communauté de nos clients pour vendre vos\n          articles plus facilement !\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "icon icon64 idtroc-share2" }),
      _vm._v(" "),
      _c("h1", [_vm._v("Ils parlent de l’IDTROC !")]),
      _vm._v(" "),
      _c("div", { staticClass: "cols cont" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "video" }, [
            _c("iframe", {
              staticStyle: { position: "absolute", border: "0" },
              attrs: {
                width: "100%",
                height: "100%",
                src: "https://www.youtube.com/embed/MEQ60VlHxPc",
                allow:
                  "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: "",
                title: "on parle d'IDTROC dans le journal tv france2"
              }
            })
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Journal TV France 2")]),
          _vm._v(" "),
          _c("p", { staticClass: "left" }, [
            _vm._v(
              "\n          « Forcement on se rappelle quand on leur a mis, mais je me dis que\n          cela va faire très plaisir à quelqu’un »\n          "
            ),
            _c("br"),
            _vm._v("en magasin Okaïdi - Obaïbi\n        ")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "video" }, [
            _c("iframe", {
              staticStyle: { position: "absolute", border: "0" },
              attrs: {
                width: "100%",
                height: "100%",
                src: "https://www.youtube.com/embed/_XrXGnwK5Zw",
                allow:
                  "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: "",
                title: "France 3 prend la parole pour IDTROC !"
              }
            })
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Journal France 3")]),
          _vm._v(" "),
          _c("p", { staticClass: "left" }, [
            _vm._v(
              '\n          "C\'est le mode de consommation tendance, le recyclable !"\n          '
            ),
            _c("br"),
            _vm._v("Vente de livres chez Oxybul\n        ")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "video" }, [
            _c("iframe", {
              staticStyle: { position: "absolute" },
              attrs: {
                title: "les clients parlent d'idtroc sur youtube by google",
                width: "100%",
                height: "100%",
                src: "https://www.youtube.com/embed/vLU7y0w02qE",
                frameborder: "0",
                allow:
                  "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Les clients en parlent")]),
          _vm._v(" "),
          _c("p", { staticClass: "left" }, [
            _vm._v("interview de clients et utilisateurs IDTROC")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "icon icon64 idtroc-marker" }),
      _vm._v(" "),
      _c("h2", [
        _c("br"),
        _vm._v(
          "Retrouvez-nous dans votre magasin Okaïdi, Obaïbi, Oxybul\n      et ÏDKIDS pour participer aux ventes !\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cols cont" }, [
        _c("div", { staticClass: "col forthy centered" }, [
          _c("figure", { staticClass: "centered" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.okaidi.fr/idtroc-4",
                  title: "vente de vêtement d'occasion obaïbi acceder au site",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/SVG/okaidi_logo.svg"),
                    width: "120",
                    height: "48",
                    alt: "logo okaidi sur idtroc"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Okaïdi")]),
          _vm._v(" "),
          _c("p", {}, [_vm._v("Vêtements enfant 4-14 ans")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "hyperlink",
              attrs: {
                href: "https://www.okaidi.fr/idtroc-4",
                title: "vente de vêtement d'occasion okaïdi acceder au site",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("idtroc sur Okaïdi")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col forthy centered" }, [
          _c("figure", { staticClass: "centered" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.okaidi.fr/idtroc-4",
                  title: "vente de vêtement d'occasion obaïbi acceder au site",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/SVG/obaibi_logo.svg"),
                    width: "120",
                    height: "48",
                    alt: "logo obaibi sur idtrocf"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Obaïbi")]),
          _vm._v(" "),
          _c("p", {}, [_vm._v("Vêtements bébé 0-4 ans")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "hyperlink",
              attrs: {
                href: "https://www.okaidi.fr/idtroc-4",
                title: "vente de vêtement d'occasion obaïbi acceder au site",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("idtroc sur Obaïbi")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col forthy centered" }, [
          _c("figure", { staticClass: "centered" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.oxybul.com/id-troc",
                  title:
                    "vente de livres jeux et jouets d'occasion Oxybul acceder au site",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/SVG/oxybul_logo.svg"),
                    width: "120",
                    height: "48",
                    alt: "logo oxybul sur idtroc"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Oxybul")]),
          _vm._v(" "),
          _c("p", [_vm._v("Livres jeux et jouets 0-12 ans")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "hyperlink",
              attrs: {
                href: "https://www.oxybul.com/id-troc",
                title:
                  "vente de livres jeux et jouets d'occasion Oxybul acceder au site",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("idtroc sur Oxybul")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col forthy centered" }, [
          _c("figure", { staticClass: "centered" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.catimini.com/fr-fr/website/465-idtroc",
                  title:
                    "vente de livres jeux et jouets d'occasion Oxybul acceder au site",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/SVG/catimini_logo.svg"),
                    width: "120",
                    height: "48",
                    alt: "logo catimini sur idtroc"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Catimini")]),
          _vm._v(" "),
          _c("p", [_vm._v("Vêtements bébé et enfant 0-14 ans")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "hyperlink",
              attrs: {
                href: "https://www.catimini.com/fr-fr/website/465-idtroc",
                title:
                  "vente de vêtement enfant d'occasion Catimini acceder au site",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v("idtroc sur Catimini")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "centered" }, [
        _c("div", { staticClass: "icon icon64 idtroc-give centered inline" })
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h2", [
        _vm._v("\n      Que deviennent vos invendus non retirés ?\n      "),
        _c("br"),
        _vm._v(" "),
        _c("b", [
          _vm._v(
            "Nous nous engageons à faire don de vos invendus aux associations et\n        organismes partenaires."
          )
        ])
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "cols cont" }, [
        _c("div", { staticClass: "col centered" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/images/lovebag.png"),
              alt: "le love bag avec idtroc seconde vie",
              height: "120"
            }
          }),
          _vm._v(" "),
          _c("h4", [_vm._v("OKAÏDI et LE LOVEBAG")]),
          _vm._v(" "),
          _c("p", { staticClass: "cont justified" }, [
            _vm._v(
              "\n          Vos dons, sont triés, redistribués ou recyclés avec le LOVE BAG dans\n          une démarche éco-responsable.\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col centered" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/images/oxybul_dons.svg"),
              alt: "logo le relais avec jacadi paris",
              height: "120"
            }
          }),
          _vm._v(" "),
          _c("h4", [_vm._v("Oxybul et les accosiations locales")]),
          _vm._v(" "),
          _c("p", { staticClass: "col justified" }, [
            _vm._v(
              "\n          Chaque magasin parraine une association locale qui agit en faveur\n          des enfants et des familles et lui redistribue vos dons.\n        "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c6d241d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6d241d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Idtroc.vue
// module id = null
// module chunks = 